"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceConfig = void 0;
const resolveConfigValue_1 = require("./resolveConfigValue");
/**
 * Substitutes configuration values into a provided string.
 * Performs a string substitution using configuration values
 * @param base The string into which substitutions will be made; contains tokens that are
 * referenced in the `replacements` argument.
 * @param replacements A map of tokens to configuration value providers. The providers are
 * resolved and the values are substituted into the `base` string, replacing the tokens.
 * @example replaceConfig('https://[host]', { '[host]': envConfig('HOST') })
 * @returns the string after substitution is complete
 */
const replaceConfig = (base, replacements) => {
    return async () => {
        const resolved = await Promise.all(Object.entries(replacements)
            .map(async ([token, replacement]) => [token, await (0, resolveConfigValue_1.resolveConfigValue)(replacement)]));
        return resolved.reduce((result, [token, replacement]) => result.replace(token, replacement), await (0, resolveConfigValue_1.resolveConfigValue)(base));
    };
};
exports.replaceConfig = replaceConfig;
